import { HttpService } from "../../modules/shared/services/http.service";
import { Quote, QuoteCreateDto, QuoteUpdateDto, QuoteResponse, QuoteFilters, QuoteSort } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

/**
 * Quote API Actions
 * All API calls for quote management using HttpService
 */

export const createQuote = async (data: QuoteCreateDto): Promise<Quote> => {
	const response = await HttpService.post("api/v1/quotes", data, headers, true);
	return response;
};

export const updateQuote = async (id: string, data: Partial<QuoteCreateDto>): Promise<Quote> => {
	const response = await HttpService.patch(`api/v1/quotes/${id}`, data, headers, true);
	return response;
};

export const getQuoteById = async (id: string): Promise<Quote> => {
	const response = await HttpService.get(`api/v1/quotes/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getQuotes = async (query?: Record<string, string | number | boolean>): Promise<QuoteResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/quotes${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteQuote = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/quotes/${id}`, { "x-custom-lang": "en" }, true);
};

export const getUserQuotes = async (userId: string, query?: Record<string, string | number | boolean>): Promise<QuoteResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/quotes/user/${userId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getQuotesWithFilters = async (filters?: QuoteFilters, sort?: QuoteSort[], page?: number, limit?: number): Promise<QuoteResponse> => {
	const query: Record<string, string | number | boolean> = {};
	
	if (filters) {
		if (filters.userId) query.userId = filters.userId;
		if (filters.jobId) query.jobId = filters.jobId;
		if (filters.escrowId) query.escrowId = filters.escrowId;
		if (filters.purchaseTypeId) query.purchaseTypeId = filters.purchaseTypeId;
		if (filters.statusId) query.statusId = filters.statusId;
	}
	
	if (sort && sort.length > 0) {
		query.sort = JSON.stringify(sort);
	}
	
	if (page) query.page = page;
	if (limit) query.limit = limit;
	
	return getQuotes(query);
};

export const getUserQuotesWithFilters = async (userId: string, filters?: QuoteFilters, sort?: QuoteSort[], page?: number, limit?: number): Promise<QuoteResponse> => {
	const query: Record<string, string | number | boolean> = {};
	
	if (filters) {
		if (filters.jobId) query.jobId = filters.jobId;
		if (filters.escrowId) query.escrowId = filters.escrowId;
		if (filters.purchaseTypeId) query.purchaseTypeId = filters.purchaseTypeId;
		if (filters.purchaseTypeIds) query.purchaseTypeIds = filters.purchaseTypeIds;
		if (filters.statusId) query.statusId = filters.statusId;
	}
	
	if (sort && sort.length > 0) {
		query.sort = JSON.stringify(sort);
	}
	
	if (page) query.page = page;
	if (limit) query.limit = limit;
	
	return getUserQuotes(userId, query);
};

export const getUserJobQuotes = async (userId: string, jobIds: string[]): Promise<any> => {
	const data = {
		userId,
		jobIds
	};
	const response = await HttpService.post("api/v1/quotes/user-jobs", data, headers, true);
	return response;
};

export const getQuotesByJobIds = async (jobIds: string[]): Promise<any> => {
	const data = {
		jobIds
	};
	const response = await HttpService.post("api/v1/quotes/by-job-ids", data, headers, true);
	return response;
};
